import React from 'react';
import k3 from '../assets/karate/gallery/3.jpg';
import k4 from '../assets/karate/gallery/edouard2.jpg';
import k5 from '../assets/karate/gallery/12.jpg';
import k6 from '../assets/karate/gallery/guillaume-nico.jpg';
import k8 from '../assets/karate/gallery/11.jpg';
import k9 from '../assets/karate/gallery/10.jpg';

const GallerieK = () => {
  const images = [
    
    { src: k4, alt: "Technique de karaté", title: "Précision technique" },
    { src: k8, alt: "Pratique traditionnelle", title: "Tradition" },
    { src: k9, alt: "Cours collectif", title: "Apprentissage" },
    { src: k3, alt: "Groupe d'entraînement", title: "Esprit d'équipe" },
    { src: k6, alt: "Entraînement en binôme", title: "Travail à deux" },
    { src: k5, alt: "Session de karaté", title: "Concentration" },
    
  ];

  return (
    <section className="relative py-20 bg-gradient-to-br from-white via-gray-50 to-white overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-primary/5 to-red-100/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-red-50/30 to-primary/5 rounded-full blur-3xl"></div>
      
      <div className="relative container mx-auto px-6 lg:px-8">
        {/* En-tête de section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
            Galerie photos
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-secondary">Ka</span><span className="text-primary">raté</span> en action
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez l'ambiance de nos cours et l'esprit qui anime notre école 
            à travers ces moments capturés lors de nos entraînements.
          </p>
        </div>

        {/* Galerie simple et épurée - Optimisée mobile */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6 mb-16">
          {images.map((image, index) => (
            <div 
              key={index} 
              className="relative overflow-hidden rounded-xl sm:rounded-2xl aspect-square hover:scale-105 transition-transform duration-300"
            >
              <img
                alt={image.alt}
                className="w-full h-full object-cover object-top"
                src={image.src}
              />
              {/* Overlay subtil au hover sur desktop */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 hidden sm:block"></div>
            </div>
          ))}
        </div>

        {/* Section informations sur l'école */}
        <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8 border border-gray-100">
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">L'esprit ECKSD</h3>
            <p className="text-gray-600">Ce qui fait la différence dans notre approche du karaté</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Convivialité</h4>
              <p className="text-gray-600 text-xs md:text-sm">
                Une ambiance chaleureuse où chacun progresse à son rythme dans le respect mutuel.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Performance</h4>
              <p className="text-gray-600 text-xs md:text-sm">
                Un enseignement de qualité pour développer technique, force et mental.
              </p>
            </div>
            
            <div className="text-center col-span-2 md:col-span-1">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Passion</h4>
              <p className="text-gray-600 text-xs md:text-sm">
                L'amour des arts martiaux transmis par des instructeurs passionnés.
              </p>
            </div>
          </div>
        </div>

        {/* Call to action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-primary to-red-600 rounded-3xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Envie de nous rejoindre ?</h3>
            <p className="text-gray-100 mb-6 max-w-2xl mx-auto">
              Venez découvrir notre école et ressentir l'esprit unique qui anime nos cours de karaté.
            </p>
            <a 
              href="#contact"
              className="inline-flex items-center px-8 py-4 bg-white text-primary font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              <span>Nous contacter</span>
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerieK;
